import gsap from "gsap";
import { pageReady } from "../../utils/page-ready";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const CARD_LAYOUTS = [
  { left: "-4%",  top: "19%", rotate: -10 },  // awwwards
  { left: "22%",  top: "34%", rotate:   5 },  // motion-design
  { left: "40%",  top: "20%", rotate: -10 },  // webby
  { right: "10%", top: "35%", rotate:  -6 },  // fwa
  { right: "-3%", top: "18%", rotate:  12 },  // css-design
];

const MAGNETIC_STRENGTH = 0.25;

export default class FeaturingLogos {
  constructor(el) {
    this.el = el;
    this.cards = [...el.querySelectorAll(".c-featuring-logos__card")];

    this._setPositions();
    this._initPopIn();
    this._initMagnetic();
    this._initGravity();
  }

  _setPositions() {
    this.cards.forEach((card, i) => {
      const layout = CARD_LAYOUTS[i % CARD_LAYOUTS.length];
      card.style.left = layout.left;
      card.style.right = layout.right;
      card.style.top = layout.top;
      gsap.set(card, { rotation: layout.rotate });
    });
  }

  _initPopIn() {
    gsap.set(this.cards, { yPercent: 180, autoAlpha: 0 });

    ScrollTrigger.create({
      trigger: this.el,
      start: "top 80%",
      once: true,
      onEnter: () => pageReady.ready.then(() => this._playPopIn()),
    });
  }

  _playPopIn() {
    gsap.to(this.cards, {
      yPercent: 0,
      autoAlpha: 1,
      duration: 0.9,
      ease: "back.out(1.6)",
      stagger: { amount: 0.4, from: "random" },
    });
  }

  _initMagnetic() {
    this.cards.forEach((card) => {
      const inner = card.querySelector(".c-featuring-logos__card-inner");

      card.addEventListener("mousemove", (e) => {
        const rect = card.getBoundingClientRect();
        const dx = e.clientX - (rect.left + rect.width / 2);
        const dy = e.clientY - (rect.top + rect.height / 2);
        gsap.to(inner, {
          x: dx * MAGNETIC_STRENGTH,
          y: dy * MAGNETIC_STRENGTH,
          duration: 0.4,
          ease: "power2.out",
        });
      });

      card.addEventListener("mouseleave", () => {
        gsap.to(inner, {
          x: 0,
          y: 0,
          duration: 0.8,
          ease: "elastic.out(1, 0.4)",
        });
      });
    });
  }

  _initGravity() {
    this.fallenCount = 0;

    this.cards.forEach((card) => {
      card.addEventListener("click", () => {
        if (card.dataset.fallen) return;
        card.dataset.fallen = "1";

        const rect = card.getBoundingClientRect();
        const fallDistance = window.innerHeight - rect.top + rect.height;
        const tumble = (Math.random() - 0.5) * 90;

        gsap.to(card, {
          y: `+=${fallDistance}`,
          rotation: `+=${tumble}`,
          duration: 0.8 + Math.random() * 0.3,
          ease: "power2.in",
          onComplete: () => {
            card.style.pointerEvents = "none";
            this.fallenCount++;
            if (this.fallenCount === this.cards.length) {
              gsap.delayedCall(1, () => this._resetCards());
            }
          },
        });
      });
    });
  }

  _resetCards() {
    this.fallenCount = 0;
    this.cards.forEach((card) => {
      delete card.dataset.fallen;
      card.style.pointerEvents = "";
      gsap.set(card, { y: 0, rotation: CARD_LAYOUTS[this.cards.indexOf(card)].rotate });
    });
    gsap.set(this.cards, { yPercent: 180, autoAlpha: 0 });
    this._playPopIn();
  }
}
